"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
const HashedObject_1 = require("../model/HashedObject");
class Types {
    static isTypeConstraint(types) {
        let valid = true;
        if (types !== undefined) {
            if (!Array.isArray(types)) {
                valid = false;
            }
            else {
                for (const typ of types) {
                    if ((typeof typ) !== 'string') {
                        valid = false;
                    }
                }
            }
        }
        return valid;
    }
    static satisfies(value, types) {
        let satisfies = true;
        if (types !== undefined) {
            for (const typ of types) {
                if (Types.hasType(value, typ)) {
                    satisfies = true;
                    break;
                }
            }
        }
        return satisfies;
    }
    static hasType(value, typ) {
        if (typ === 'string') {
            return (typeof value) === 'string';
        }
        else if (typ === 'number') {
            return (typeof value) === 'number';
        }
        else {
            return (value instanceof HashedObject_1.HashedObject && value.getClassName() === typ);
        }
    }
}
exports.Types = Types;
//# sourceMappingURL=Types.js.map